module.exports = __webpack_public_path__ + "img/sv29.f553e517.svg";